module.exports = __webpack_public_path__ + "static/img/prize03.804f61b5.gif";